import type { ReduxAction } from '../../types';

export interface WelcomeGuideState {
  visible: boolean;
}

const initialWelcomeGuideState = {
  visible: false,
};

export function welcomeGuideReducer(
  state: WelcomeGuideState = initialWelcomeGuideState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'TOGGLE_WELCOME_GUIDE_VISIBILITY':
      return { visible: payload };

    default:
      return state;
  }
}
